import {
  GET_OVERVIEW,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_PROPOSALS_BY_PLANS,
  GET_DEMOGRAPHIC_DATA,
  GET_OVERVIEW_MAPS_DATA,
  GET_OVERVIEW_SALES_FORECAST,
  GET_PROPOSALS_SITUATION,
} from './actionType';

const INIT_STATE = {
  metrics: null,
  error: {},
  success: '',
  loading: true,
  demographic: {},
  markers: [],
  successMarkers: '',
  successDemographic: '',
  proposalsByPlans: [],
  successProposalsByPlans: '',
  salesForecast: {},
  successForecast: '',
  proposalsBySituation: null,
  successSituation: '',
  loadingSalesEvolution: true,
  loadingByPlans: true,
  loadingDemo: true,
  loadingMap: true,
  loadingBySituation: true,
};

const Overview = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_OVERVIEW:
          return {
            ...state,
            metrics: action.payload.data,
            success: '',
            error: {},
            loading: false,
          };
        case GET_PROPOSALS_BY_PLANS:
          return {
            ...state,
            proposalsByPlans: action.payload.data,
            successProposalsByPlans: '',
            error: {},
            loadingByPlans: false,
          };
        case GET_DEMOGRAPHIC_DATA:
          return {
            ...state,
            demographic: action.payload.data,
            successDemographic: '',
            error: {},
            loadingDemo: false,
          };
        case GET_OVERVIEW_MAPS_DATA:
          return {
            ...state,
            markers: action.payload.data,
            successMarkers: '',
            error: {},
            loadingMap: false,
          };
        case GET_OVERVIEW_SALES_FORECAST:
          return {
            ...state,
            salesForecast: action.payload.data,
            successForecast: '',
            error: {},
            loadingSalesEvolution: false,
          };
        case GET_PROPOSALS_SITUATION:
          return {
            ...state,
            proposalsBySituation: action.payload.data,
            successSituation: '',
            error: {},
            loadingBySituation: false,
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_OVERVIEW:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loading: false,
          };
        case GET_PROPOSALS_BY_PLANS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loadingByPlans: false,
          };
        case GET_DEMOGRAPHIC_DATA:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loadingDemo: false,
          };
        case GET_OVERVIEW_MAPS_DATA:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loadingMap: false,
          };
        case GET_OVERVIEW_SALES_FORECAST:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loadingSalesEvolution: false,
          };
        case GET_PROPOSALS_SITUATION:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loadingBySituation: false,
          };
        default:
          return { ...state };
      }
    case GET_OVERVIEW: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_PROPOSALS_BY_PLANS: {
      return {
        ...state,
        loadingByPlans: true,
      };
    }
    case GET_DEMOGRAPHIC_DATA: {
      return {
        ...state,
        loadingDemo: true,
      };
    }
    case GET_OVERVIEW_MAPS_DATA: {
      return {
        ...state,
        loadingMap: true,
      };
    }
    case GET_OVERVIEW_SALES_FORECAST: {
      return {
        ...state,
        loadingSalesEvolution: true,
      };
    }
    case GET_PROPOSALS_SITUATION: {
      return {
        ...state,
        loadingBySituation: true,
      };
    }
    default:
      return { ...state };
  }
};

export default Overview;
